"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "getColor", {
  enumerable: true,
  get: function get() {
    return _getColor["default"];
  }
});
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _menu = _interopRequireDefault(require("cccisd-icons/svg/menu"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _reactColor = require("react-color");
var _style = _interopRequireDefault(require("./style.css"));
var _color = _interopRequireDefault(require("color"));
var _colors = _interopRequireDefault(require("./colors.css"));
var _getColor = _interopRequireDefault(require("./getColor.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var appColors = [{
  name: 'primaryColor'
}, {
  name: 'successColor'
}, {
  name: 'infoColor'
}, {
  name: 'warningColor'
}, {
  name: 'dangerColor'
}];

/** Color picker */
var CccisdColorPicker = function CccisdColorPicker(props) {
  var value = props.value,
    _onChange = props.onChange;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showColorPicker = _useState2[0],
    setDisplayColorPicker = _useState2[1];
  var _useState3 = (0, _react.useState)(value && value.startsWith('#') ? value : '#666666'),
    _useState4 = _slicedToArray(_useState3, 2),
    color = _useState4[0],
    setColor = _useState4[1];
  var toggleColorPicker = function toggleColorPicker() {
    _onChange(color);
    setDisplayColorPicker(!showColorPicker);
  };
  var isLight = (0, _color["default"])(color).luminosity() > 0.5;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, appColors.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: item.name,
      className: (0, _classnames4["default"])(_style["default"].color, _defineProperty({}, _style["default"].selected, value === item.name)),
      style: {
        backgroundColor: _colors["default"][item.name]
      },
      onClick: function onClick() {
        setDisplayColorPicker(false);
        _onChange(item.name);
      }
    });
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames4["default"])(_style["default"].more, _defineProperty({}, _style["default"].show, showColorPicker))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].cover,
    onClick: function onClick() {
      return setDisplayColorPicker(false);
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactColor.ChromePicker, {
    disableAlpha: true,
    color: color,
    onChange: function onChange(obj) {
      setColor(obj.hex);
      _onChange(obj.hex);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames4["default"])(_style["default"].color, _style["default"].customColor, _defineProperty(_defineProperty({}, _style["default"].selected, value && value.startsWith('#')), _style["default"].light, isLight)),
    style: {
      backgroundColor: color
    },
    onClick: toggleColorPicker
  }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))));
};
CccisdColorPicker.propTypes = {
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
CccisdColorPicker.defaultProps = {
  onChange: function onChange() {}
};
var _default = exports["default"] = CccisdColorPicker;